export default __webpack_public_path__ + "static/media/rastreador.01e9cb2d.png";